import { LogoutWarningAction, LogoutWarningActionType } from "./logout-warning-actions";

const INITIAL_STATE = {
    logoutWarningVisible: false,
};

export function logoutWarningReducer(state = INITIAL_STATE, action: LogoutWarningAction) {
    switch (action.type) {
        case LogoutWarningActionType.VISIBLE:
            return {...state, logoutWarningVisible: true};
        case LogoutWarningActionType.INVISIBLE:
            return {...state, logoutWarningVisible: false};
        default:
            return state;
    }
}
